import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';

const LeaveFormConfirmation = ({ onKeepEditing, onDiscard }) => (
    <div className="leave-form-confirmation">
        <div className="row">
            <div className="col d-flex flex-column justify-content-center">
                <h2>Are you sure you want to close?</h2>
                <div>
                    <span className="d-block mt-3 mb-2">Any information entered will not be saved.</span>
                </div>
            </div>
        </div>
        <footer className="row justify-content-between mt-3">
            <div className="col-5">
                <Button
                    className="btn cc-btn-secondary btn-block"
                    onClick={ onKeepEditing }>
                    Keep editing
                </Button>
            </div>
            <div className="col-5">
                <Button
                    className="btn cc-btn-primary btn-block"
                    onClick={ onDiscard }>
                    Discard changes
                </Button>
            </div>
        </footer>
    </div>
);

LeaveFormConfirmation.propTypes = {
    onKeepEditing: PropTypes.func.isRequired,
    onDiscard: PropTypes.func.isRequired,
};

export default LeaveFormConfirmation;
